import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";

export const useCustomEmotions = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/emotions").then((r) => setItems(r.data)).catch((e) => logError("Emotions load failed:", e));
  }, []);

  const add = useCallback(async (emoji, label) => {
    try {
      const { data } = await api.post("/emotions", { emoji, label });
      setItems((l) => [...l, data]);
      return data;
    } catch (e) {
      toast.error(errMsg(e, "Could not add emotion"));
      return null;
    }
  }, []);

  const remove = useCallback(async (id) => {
    try {
      await api.delete(`/emotions/${id}`);
      setItems((l) => l.filter((x) => x.id !== id));
    } catch (e) {
      toast.error(errMsg(e, "Could not remove emotion"));
    }
  }, []);

  return { items, add, remove };
};
